"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.byIds = byIds;
exports.byIdsStr = byIdsStr;

var _immutable = require("immutable");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _params = require("hub-http/helpers/params");

var DEAL_ID_KEY = 'dealId';

function byIds(dealIds) {
  (0, _invariant.default)(_immutable.List.isList(dealIds), 'DealsAPIQuery: expected dealIds to be a List but got %s', dealIds);
  return (0, _immutable.Map)().set(DEAL_ID_KEY, dealIds);
}

function byIdsStr(dealIds) {
  return (0, _params.stringify)(byIds(dealIds).toJS());
}